import { render, staticRenderFns } from "./rubric_actions_dropdown.vue?vue&type=template&id=a594f13e&scoped=true&"
import script from "./rubric_actions_dropdown.vue?vue&type=script&lang=js&"
export * from "./rubric_actions_dropdown.vue?vue&type=script&lang=js&"
import style0 from "./rubric_actions_dropdown.vue?vue&type=style&index=0&id=a594f13e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a594f13e",
  null
  
)

export default component.exports